// extracted by mini-css-extract-plugin
export default {"become_partner_btn":"Button_become_partner_btn__bO0Mc"};